export function packageDeliveStoreInitState () {
  return {
    logisticList: [],
    selectedDeliver: '', // TCatLogistic(黑貓) or KTJLogistic(嘉里)
    packageList: [],
    step3Data: {},
    KTJNoPickUpOrders: null,
    packageCountLimit: {
      max: 50,
      min: 1
    },
    communityList: [],
    pkgNextLoading: false,
    packageTypeOptions: [] // 包裹種類
  }
}

export default {
  packageDeliveStoreInitState
}
